import type { NotificationArgsProps } from 'antd';
import * as CryptoJS from 'crypto-js';


type NotificationPlacement = NotificationArgsProps['placement'];

export class Utils {

  static async getStorage(key: string) {
    try {
      return sessionStorage.getItem(key);
    } catch (e) {
      console.error(e);
    }
  }

  static setStorage(key: string, payload: any) {
    try {
      return localStorage.setItem(key, payload);
    } catch (e) {
      console.error(e);
    }
  }

  static defaultTable = () => {
    return Array.from({ length: 10 }, (_, index) => ({
      id: index + 1,
      avatar: null,
    }));
  };

  static yandexCity(payload: string): Promise<any> {

    return new Promise((resolve) => {
      let url = 'https://geocode-maps.yandex.ru/1.x/?apikey=d02fa342-535c-4955-bfd8-651249e6795b&geocode=' + payload + '&kind=district&results=10&format=json';
      fetch(url)
        .then(response => response.text())
        .then(result => {
          resolve(JSON.parse(result));
          localStorage.setItem('vd', result);
        })
        .catch(error => console.error('error', error));
    });
  }

  static InfoOpenNotification = (
    placement: NotificationPlacement,
    message?: string,
    duration?: number | null,
    api?: any) => {
    api.info({
      message: message,
      placement,
      duration: duration,
    });
  };

  static decrypt(hex: any) {
    try {
      if (hex) {
        const bytes = CryptoJS.AES.decrypt(hex, '02aab0f70eca03ff2e2397cb91076262');
        const decryptedText = bytes.toString(CryptoJS.enc.Utf8);

        // Проверяем, если расшифрованный текст пустой
        if (!decryptedText) {
          return [];
        }

        // Пытаемся распарсить JSON
        return JSON.parse(decryptedText);
      }else {
        return []
      }
    } catch (error) {
      console.error('Ошибка при расшифровке:', error);
      // Возвращаем пустой массив или обрабатываем ошибку другим образом
      return [];
    }
  }

  static async encrypt(hex: string) {
    return CryptoJS.AES.encrypt(hex, '02aab0f70eca03ff2e2397cb91076262').toString();
  }

  static getStorageCrypt(key: string) {
    try {
      return this.decrypt(sessionStorage.getItem(key));
    } catch (e) {
      return e;
    }
  }

  static getUserInfo() {
    try {
      return this.getStorageCrypt('_yl105000');
    } catch (e) {
      return e;
    }
  }

  static ErrorOpenNotification = (
    placement: NotificationPlacement,
    duration?: number | null,
    message?: string,
    description?: string | null,
    api?: any) => {
    api.error({
      message: message,
      description: description,
      duration,
      placement,
    });
  };
}
